import { render, staticRenderFns } from "./mb-area-select.vue?vue&type=template&id=2d2fedb3&scoped=true&"
import script from "./mb-area-select.vue?vue&type=script&lang=ts&"
export * from "./mb-area-select.vue?vue&type=script&lang=ts&"
import style0 from "./mb-area-select.vue?vue&type=style&index=0&id=2d2fedb3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2fedb3",
  null
  
)

export default component.exports